import React from 'react'
import { RealEstateDataPageComponentData, GridLink } from 'types'
import { Col, Container, Row } from 'react-bootstrap'

const MOCKDATA: RealEstateDataPageComponentData = {
  gridLinks: [
    {
      id: 1,
      col: 12,
      link: "https://site.com/propiedades%20destacadas",
      image: "https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      title: "Propiedades destacadas"
    },
    {
      id: 2,
      col: 8,
      link: "https://site.com/departamentos",
      image: "https://images.pexels.com/photos/144632/pexels-photo-144632.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      title: "Departamentos"
    },
    {
      id: 3,
      col: 4,
      link: "https://site.com/casas",
      image: "https://images.pexels.com/photos/226407/pexels-photo-226407.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      title: "Casas"
    },
    {
      id: 4,
      col: 4,
      link: "https://site.com/tasaciones",
      image: "https://images.pexels.com/photos/720329/pexels-photo-720329.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      title: "Tasaciones"
    },
    {
      id: 5,
      col: 8,
      link: "https://site.com/barrios%20cerrados",
      image: "https://images.pexels.com/photos/280221/pexels-photo-280221.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      title: "Barrios cerrados"
    }
  ]
}

const GridCards = (props: RealEstateDataPageComponentData) => {

  const { isDemo } = props
  const { title, gridLinks } = isDemo ? MOCKDATA : props

  const GridLink = require(`@components/cards-gridLink/1`)?.default

  return (
    <section id="grid-links" className={"grid-links-section" + (gridLinks?.length === 0 ? ' d-none' : '')}>
      { title ?
        <Container fluid className="title-grid-wrapper">
            <Row>
              <Col xs={12}>
                <h2 className="section-title pb-lg-5">{title}</h2>
              </Col>
            </Row>
        </Container> : null }
      <Container fluid id="grid-wrapper">
          <Row className="row-gap-4">
            { gridLinks?.map((gridDataLink: GridLink, index: number) => (    
                <Col lg={gridDataLink?.col} key={index}>
                  <GridLink dataLink={gridDataLink}/>  
                </Col> ))}
          </Row>
      </Container>
    </section>
  )
}

export default GridCards
